import React, { useState } from "react";
import "./competitorsuperadmin.css";

const CompetitorSelection = ({
  search,
  options,
  loading,
  disabled,
  error,
  onSearchChange,
  onSelect,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className="competitor-selector">
      <label className="competitor-selector-label">
        Select client company *
      </label>

      <div className="competitor-selector-input-wrapper">
        <input
          type="text"
          className={`competitor-selector-input ${error ? "error" : ""}`}
          value={search}
          placeholder="Search company..."
          disabled={disabled}
          onChange={(e) => {
            onSearchChange(e.target.value);
            setShowDropdown(true);
          }}
          onFocus={() => search && setShowDropdown(true)}
          onBlur={() => {
            // Delay so click can register
            setTimeout(() => setShowDropdown(false), 150);
          }}
        />

        {showDropdown && (
          <div className="competitor-selector-dropdown">
            {/* Less than 3 chars */}
            {!loading && search.length > 0 && search.length < 3 && (
              <div className="competitor-selector-empty">
                Type at least 3 characters
              </div>
            )}

            {/* Loading */}
            {loading && (
              <div className="competitor-selector-loading">
                Loading...
              </div>
            )}

            {/* No results */}
            {!loading &&
              search.length >= 3 &&
              options.length === 0 && (
                <div className="competitor-selector-empty">
                  No companies found
                </div>
              )}

            {/* Results */}
            {/* {!loading &&
              options.map((company) => (
                <div
                  key={company.id}
                  className="competitor-selector-item"
                  onMouseDown={() => {
                    onSelect(company);
                    setShowDropdown(false);
                  }}
                >
                  <div className="competitor-name">
                    {company.company_name_for_growth_iq}
                  </div>
                  {company.industry && (
                    <div className="competitor-industry">
                      {company.industry}
                    </div>
                  )}
                </div>
              ))} */}
              {!loading &&
                options.map((company) => {
                    const name = company.company_name_for_growth_iq;

                    // treat "", null, undefined, "   " as NO industry
                    const industry =
                    typeof company.industry === "string" &&
                    company.industry.trim().length > 0
                        ? company.industry.trim()
                        : null;

                    return (
                    <div
                        key={company.id}
                        className="competitor-selector-item"
                        onMouseDown={() => {
                        const name = company.company_name_for_growth_iq;
                        const industry =
                            typeof company.industry === "string" &&
                            company.industry.trim().length > 0
                            ? company.industry.trim()
                            : null;

                        const displayValue = industry
                            ? `${name} (${industry})`
                            : name;

                        onSearchChange(displayValue); // 🔥 THIS WAS MISSING
                        onSelect(company);
                        setShowDropdown(false);
                        }}
                    >
                        <div className="competitor-name">
                        {industry ? `${name} (${industry})` : name}
                        </div>
                    </div>
                    );
                })}
          </div>
        )}
      </div>

      {error && (
        <div className="competitor-selector-error">
          {error}
        </div>
      )}
    </div>
  );
};

export default CompetitorSelection;